export default __webpack_public_path__ + "static/media/no-image-available.e913f686.jpg";